import React, { useState, useEffect } from 'react';

// Champ de saisie des IDs de projets (type "gallery")
const ProjectsInput = ({ projects, onChange }) => {
  const [inputValue, setInputValue] = useState(
    Array.isArray(projects) ? projects.join('\n') : ''
  );

  // Mettre à jour l'état local quand les projets changent depuis l'extérieur
  useEffect(() => {
    setInputValue(Array.isArray(projects) ? projects.join('\n') : '');
  }, [projects]);

  const handleChange = (e) => {
    // Garder la valeur brute telle quelle pendant la saisie
    setInputValue(e.target.value);
  };

  const handleBlur = () => {
    // Ne traiter la valeur que lorsque l'utilisateur quitte le champ
    if (inputValue.trim()) {
      // Diviser d'abord par les sauts de ligne, puis par les virgules
      const projectIds = inputValue
        .split(/[\n,]+/) // Divise par les retours à la ligne ou les virgules
        .map(id => {
          const trimmed = id.trim();
          if (!trimmed) return null;
          const parsed = parseInt(trimmed, 10);
          return isNaN(parsed) ? null : parsed;
        })
        .filter(id => id !== null);

      onChange(projectIds);
    } else {
      onChange([]);
    }
  };

  return (
    <>
      <textarea
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
        placeholder="Ex: 1001,1002,1003 ou un ID par ligne"
        rows="4"
      />
      <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
        Vous pouvez séparer les IDs par des virgules ou mettre un ID par ligne.
      </p>
      {Array.isArray(projects) && projects.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2">
          {projects.map((projectId, idx) => (
            <span
              key={idx}
              className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200"
            >
              {projectId}
              <button
                type="button"
                onClick={() => {
                  const newProjects = [...projects];
                  newProjects.splice(idx, 1);
                  onChange(newProjects);
                }}
                className="ml-1.5 inline-flex items-center justify-center h-4 w-4 rounded-full text-blue-400 hover:text-blue-600 dark:text-blue-300 dark:hover:text-blue-100 focus:outline-none"
              >
                <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </span>
          ))}
        </div>
      )}
    </>
  );
};

export default ProjectsInput;
